import {HomeMatchConfigurationSourceSection, PreferencesSurveySource} from "@pg-rp/common-types";

export enum HomeMatchConfigurationSourceSectionTrigger {
    SUMMARY_MODAL = "summaryModal",
    STAY_MODAL = "stayModal"
}

interface IGetHomeMatchConfigurationSourceSectionParams {
    preferencesSurveySource: PreferencesSurveySource;
    trigger: HomeMatchConfigurationSourceSectionTrigger;
}

export const getHomeMatchConfigurationSourceSection = (params: IGetHomeMatchConfigurationSourceSectionParams): HomeMatchConfigurationSourceSection => {
    const {preferencesSurveySource, trigger} = params;

    if (preferencesSurveySource === PreferencesSurveySource.ONBOARDING) {
        return trigger === HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
            ? HomeMatchConfigurationSourceSection.KM_ONBOARDING_MODAL
            : HomeMatchConfigurationSourceSection.KM_ONBOARDING_STAY;
    }

    return trigger === HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
        ? HomeMatchConfigurationSourceSection.KM_PREFERENCES_MODAL
        : HomeMatchConfigurationSourceSection.KM_PREFERENCES_STAY;
};
import {HomeMatchConfigurationSourceSection, PreferencesSurveySource} from "@pg-rp/common-types";

export enum HomeMatchConfigurationSourceSectionTrigger {
    SUMMARY_MODAL = "summaryModal",
    STAY_MODAL = "stayModal"
}

interface IGetHomeMatchConfigurationSourceSectionParams {
    preferencesSurveySource: PreferencesSurveySource;
    trigger: HomeMatchConfigurationSourceSectionTrigger;
}

export const getHomeMatchConfigurationSourceSection = (params: IGetHomeMatchConfigurationSourceSectionParams): HomeMatchConfigurationSourceSection => {
    const {preferencesSurveySource, trigger} = params;

    if (preferencesSurveySource === PreferencesSurveySource.ONBOARDING) {
        return trigger === HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
            ? HomeMatchConfigurationSourceSection.KM_ONBOARDING_MODAL
            : HomeMatchConfigurationSourceSection.KM_ONBOARDING_STAY;
    }

    return trigger === HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
        ? HomeMatchConfigurationSourceSection.KM_PREFERENCES_MODAL
        : HomeMatchConfigurationSourceSection.KM_PREFERENCES_STAY;
};
